import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import Button from 'src/components/Button';
import ModalLayout, { MobileModalType, ModalHeaderTitle as ModalHeaderTitleBase, ModalContent, ModalHeaderDescriptionRow, ModalFooter, ModalHeader, ModalLoading as ModalLoadingBase } from 'src/components/ModalLayout';
import { useGetPreferredLanguagesQuery } from 'src/hooks/usePreferredLanguagesQuery';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalNavButtonType, ModalType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
import Content from './Content';
import usePreferredLanguagesSelection from './usePreferredLanguagesSelection';
const ModalLoading = styled(ModalLoadingBase)`
  height: 392px;
`;
const ModalSpacer = styled.div`
  height: 48px;
  flex-shrink: 0;
`;
const ModalHeaderTitle = styled(ModalHeaderTitleBase)`
  font-size: 30px;
  line-height: 40px;
`;
const EditPreferredLanguageModal = () => {
  const closeModal = useSetAtom(closeModalAtom);
  const {
    draftSelectedPreferredLanguages,
    setDraftSelectedPreferredLanguages,
    saveChanges
  } = usePreferredLanguagesSelection();
  const {
    data: preferredLanguagesData,
    isLoading: isLoadingPreferredLanguages
  } = useGetPreferredLanguagesQuery();
  const {
    t
  } = useTranslation();
  const handleClickSave = () => {
    pushEvent({
      eventName: EVENT_NAME.ANYWHERE__CLICK_APPLY_PREFERRED_LANGUAGE,
      eventType: EVENT_TYPE.EDIT_PROFILE,
      eventParams: {
        action_category: 'click',
        tab: 'anywhere',
        page: 'change_preferred_language',
        target: 'apply_preferred_language',
        preferred_language: (draftSelectedPreferredLanguages ?? []).slice(0, 5).map(preferredLanguage => preferredLanguage.code).join(',')
      }
    });
    saveChanges();
    closeModal(ModalType.EDIT_PREFER_LANGUAGE);
  };
  return <ModalLayout isDim navButtonType={ModalNavButtonType.BACK} mobileNavButtonType={ModalNavButtonType.BACK} mobileType={MobileModalType.BOTTOM_SHEET} onBack={() => closeModal(ModalType.EDIT_PREFER_LANGUAGE)} data-sentry-element="ModalLayout" data-sentry-component="EditPreferredLanguageModal" data-sentry-source-file="index.tsx">
      <ModalSpacer data-sentry-element="ModalSpacer" data-sentry-source-file="index.tsx" />
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <ModalHeaderTitle mobileType={MobileModalType.BOTTOM_SHEET} data-sentry-element="ModalHeaderTitle" data-sentry-source-file="index.tsx">
          {t('profile_pref_lang_title')}
        </ModalHeaderTitle>
        <ModalHeaderDescriptionRow data-sentry-element="ModalHeaderDescriptionRow" data-sentry-source-file="index.tsx">
          {t('profile_pref_lang_desc', {
          num: preferredLanguagesData?.data.maxPreferredLanguageCount || 5
        })}
        </ModalHeaderDescriptionRow>
      </ModalHeader>
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
        {!draftSelectedPreferredLanguages || !preferredLanguagesData?.data || isLoadingPreferredLanguages ? <ModalLoading /> : <Content draftSelectedPreferredLanguages={draftSelectedPreferredLanguages} setDraftSelectedPreferredLanguages={setDraftSelectedPreferredLanguages} preferredLanguagesData={preferredLanguagesData.data} />}
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <Button id='edit-prefer-language-save' onClick={handleClickSave} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t('pref_lang_popup_btn')}
        </Button>
      </ModalFooter>
    </ModalLayout>;
};
export default EditPreferredLanguageModal;